import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initializeCloudStore } from './services/store';
import { winter2026SeedData } from './data/winter2026SeedData';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

const root = createRoot(rootEl);
const isLocalDev = ((import.meta as ImportMeta & { env?: { DEV?: boolean } }).env?.DEV ?? false);
const localSeed = isLocalDev ? winter2026SeedData : undefined;

void initializeCloudStore(localSeed).then(
  () => {
    root.render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    );
  },
  (error) => {
    console.error('Cloud bootstrap failed.', error);
    root.render(
      <StrictMode>
        <main className="bootstrap-error" role="alert">
          <div className="bootstrap-error__panel">
            <p className="eyebrow">The Scorekeeper</p>
            <h1>League data could not load.</h1>
            <p>
              Cloudflare D1 bootstrap failed, so this page is not showing stale
              test data. Refresh the page, then check the deployment logs if it
              continues.
            </p>
          </div>
        </main>
      </StrictMode>,
    );
  },
);
